(function()
{
 	var app = angular.module("app");

 	app.controller('TopicController', ['$scope', '$rootScope', '$http', "functions", function($scope, $rootScope, $http, functions)
	{
		/**
		 * Load an existing object.
		 * @param  int id ID of the object to load.
		 */
  		// $scope.load = function(id)
  		// {
  		// 	if(id <= 0)
  		// 	{
  		// 		return;
  		// 	}

  		// 	$http.get('/ajaxdata/get/topic/' + id).
				// success(function(data, status, headers, config)
				// {
				// 	$scope.populate(data);
				// }).
				// error(function(data, status, headers, config)
				// {
				// 	error("Error Loading Topic", data, true, null);
				// });
  		// };

  		$scope.populate = function(data)
  		{
  			$rootScope.topic = data;
  			setCookie("topic_id", $rootScope.topic.topic_id, 365);

  			if($rootScope.topic.topic_is_tag)
  			{
  				for(var i=0; i<($rootScope.filters.length > 2 ? $rootScope.filters.length : 2); i++)
  				{
  					$rootScope.filters[i] = {value: []};
  				}

	  			if($rootScope.search_type == "provides")
				{
					$rootScope.filters[1].value = $rootScope.topic.topic_tags[0];
				}
				if($rootScope.search_type == "accepts")
				{
					$rootScope.filters[0].value = $rootScope.topic.topic_tags[0];
				}
				$rootScope.radius_index 	= $rootScope.distances.length-1;
				$rootScope.scale_min 		= 0;
				$rootScope.scale_max 		= 9999;
				$rootScope.transportation 	= 0;
			}
  		};

  		$scope.solutions_tab = function(event)
		{
		   	event.preventDefault();

		    $("#solutions-tab").parent().addClass("nv-tab-current");
		    $("#solutions-tab").parent().siblings().removeClass("nv-tab-current");
		    var tab 	= $("#solutions-tab").attr("href");
		    var tabs 	= $("#solutions-tab").parents(".nv-tabs").eq(0);

		    // The reason for doing .children().children() is because we don't want to affect embedded nv-tabs
		    tabs.children(".nv-tab").children(".nv-tab-content").not(tab).css("display", "none");
		    tabs.children(".nv-tab").children(tab).fadeIn(500);
		};

		$scope.show_more = function(event)
		{
			event.preventDefault();

			jQuery(".more-link").slideUp();
			jQuery('.more').slideDown();
		}
	}]);
})();
